/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { sanitize } from 'cio/utils/sanitize';
import { config } from 'cio/helpers/preview-whitelist';
import { FOUNDATION_LIQUID_TAG, FOUNDATION_CSS_LINK } from 'cio/utils/constants';

const MIN_HEIGHT = 250;

interface HtmlPreviewSignature {
  Args: {
    body: string;
    showWhitespace?: boolean;
    previewVisible?: boolean;
  };
  Element: HTMLIFrameElement;
}

export default class HtmlPreview extends Component<HtmlPreviewSignature> {
  @tracked element!: HTMLIFrameElement;

  get showWhitespace() {
    return this.args.showWhitespace ?? false;
  }

  get previewVisible() {
    return this.args.previewVisible ?? false;
  }

  willDestroy() {
    super.willDestroy();

    if (!this.isDestroyed && !this.isDestroying) {
      this.element.removeEventListener('load', this.applyBodyToIframe);
    }
  }

  @action
  onInsert(element: HTMLIFrameElement) {
    this.element = element;
    this.applyBodyToIframe();

    // Setting the content of the iframe too early disappears in firefox,
    // so do it again when the iframe is loaded
    this.element.addEventListener('load', this.applyBodyToIframe);
  }

  @action
  applyBodyToIframe() {
    if (isEmpty(this.args.body)) {
      return;
    }

    let { body: originalBody } = this.args;
    originalBody = originalBody.replace(FOUNDATION_LIQUID_TAG, FOUNDATION_CSS_LINK);

    let body = sanitize(originalBody, config);
    (window as any).emailPreviewBody = body;

    if (this.showWhitespace) {
      this.element.contentDocument!.body.style.whiteSpace = 'pre-wrap';
    }

    this.element.contentDocument!.body.innerHTML = body;

    let contents = this.element.contentDocument?.body;
    let emailHeight = 0;

    if (contents != null && typeof contents.scrollHeight === 'number') {
      emailHeight = contents.scrollHeight;
    }

    return (this.element.style.height = `${Math.max(MIN_HEIGHT, emailHeight)}px`);
  }
}
